import { createNativeStackNavigator } from "@react-navigation/native-stack";
var createStackNavigator = createNativeStackNavigator;
function getStackNavigatorProps(_children) {
  return {};
}
export {
  createStackNavigator,
  getStackNavigatorProps
};
//# sourceMappingURL=stack-navigator.js.map
